import React, { useState, useEffect, useRef } from "react";
import { preparar, enfileirarFoto } from "../fotos";
import {
  Camera,
  Loader2,
  PenLine,
  RefreshCw,
  Trash2,
} from "lucide-react";
import { Btn } from "./componentes";

/* Assinatura do cliente — canvas com ponteiro */
function Assinatura({ onChange }) {
  const ref = useRef(null);
  const draw = useRef(false);
  const [tem, setTem] = useState(false);

  useEffect(() => {
    const c = ref.current; if (!c) return;
    const r = c.getBoundingClientRect();
    c.width = r.width * 2; c.height = r.height * 2;
    const x = c.getContext("2d");
    x.scale(2, 2); x.lineWidth = 1.8; x.lineCap = "round"; x.lineJoin = "round"; x.strokeStyle = "#171C22";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  const start = (e) => { draw.current = true; const c = ref.current.getContext("2d"); const p = pos(e); c.beginPath(); c.moveTo(p.x, p.y); ref.current.setPointerCapture(e.pointerId); };
  const move = (e) => { if (!draw.current) return; const c = ref.current.getContext("2d"); const p = pos(e); c.lineTo(p.x, p.y); c.stroke(); if (!tem) { setTem(true); onChange && onChange(true); } };
  const end = () => { draw.current = false; };
  const limpar = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setTem(false); onChange && onChange(false); };

  return (
    <div>
      <div className="relative" style={{ background: "var(--card)", border: "1px dashed var(--line2)", borderRadius: "var(--r)" }}>
        <canvas ref={ref} onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end}
          style={{ width: "100%", height: 130, touchAction: "none", cursor: "crosshair", display: "block" }} />
        {!tem && <div className="absolute inset-0 flex items-center justify-center pointer-events-none text-sm t-mut2 gap-2"><PenLine size={15} />Assine com o dedo ou o mouse</div>}
        <div className="absolute" style={{ left: 16, right: 16, bottom: 22, borderBottom: "1px solid var(--line)" }} />
      </div>
      <div className="flex justify-between items-center mt-2">
        <span className="text-xs t-mut2">Assinatura do cliente na entrega do veículo</span>
        <Btn variant="g" size="xs" icon={RefreshCw} onClick={limpar}>Limpar</Btn>
      </div>
    </div>
  );
}

/* Mapa de avarias — vista superior, clique marca o ponto */
function MapaAvarias({ pontos, add, del, leitura }) {
  const clique = (e) => {
    if (leitura) return;
    const r = e.currentTarget.getBoundingClientRect();
    add({ n: pontos.length + 1, x: +(((e.clientX - r.left) / r.width) * 100).toFixed(1), y: +(((e.clientY - r.top) / r.height) * 100).toFixed(1), tipo: "Risco", desc: "" });
  };
  return (
    <div className="grid gap-4" style={{ gridTemplateColumns: "180px 1fr" }}>
      <div className="relative select-none" onClick={clique} style={{ cursor: leitura ? "default" : "crosshair", background: "var(--el)", border: "1px solid var(--line)", borderRadius: "var(--r)", padding: 8 }}>
        <svg viewBox="0 0 100 200" style={{ width: "100%", display: "block" }}>
          <rect x="16" y="8" width="68" height="184" rx="26" fill="var(--card)" stroke="var(--line2)" strokeWidth="1.4" />
          <path d="M28 40 L72 40 L66 62 L34 62 Z" fill="var(--el)" stroke="var(--line2)" strokeWidth="1" />
          <path d="M34 140 L66 140 L72 162 L28 162 Z" fill="var(--el)" stroke="var(--line2)" strokeWidth="1" />
          <rect x="32" y="68" width="36" height="66" rx="5" fill="var(--el)" stroke="var(--line2)" strokeWidth="1" />
          <rect x="8" y="46" width="9" height="22" rx="3" fill="var(--ink3)" opacity=".55" />
          <rect x="83" y="46" width="9" height="22" rx="3" fill="var(--ink3)" opacity=".55" />
          <rect x="8" y="140" width="9" height="22" rx="3" fill="var(--ink3)" opacity=".55" />
          <rect x="83" y="140" width="9" height="22" rx="3" fill="var(--ink3)" opacity=".55" />
          <rect x="30" y="12" width="40" height="6" rx="3" fill="var(--el)" stroke="var(--line2)" strokeWidth=".8" />
          <rect x="30" y="184" width="40" height="6" rx="3" fill="var(--el)" stroke="var(--line2)" strokeWidth=".8" />
        </svg>
        {pontos.map((p) => (
          <span key={p.n} className="absolute mono flex items-center justify-center"
            style={{ left: `${p.x}%`, top: `${p.y}%`, transform: "translate(-50%,-50%)", width: 19, height: 19, borderRadius: "50%", background: "var(--signal)", color: "#fff", fontSize: 10, fontWeight: 600, border: "2px solid #fff", boxShadow: "0 1px 4px rgba(0,0,0,.3)" }}>{p.n}</span>
        ))}
        {!leitura && <div className="text-xs t-mut2 text-center mt-1">Toque para marcar avaria</div>}
      </div>
      <div className="flex flex-col gap-2">
        {pontos.length === 0 && <div className="text-sm t-mut2 flex items-center h-full">Nenhuma avaria registrada. Toque no desenho para marcar riscos, amassados ou trincas.</div>}
        {pontos.map((p, i) => (
          <div key={p.n} className="flex items-center gap-2">
            <span className="mono flex-none flex items-center justify-center" style={{ width: 20, height: 20, borderRadius: "50%", background: "var(--signal-l)", color: "var(--signal)", fontSize: 11, fontWeight: 600 }}>{p.n}</span>
            <select className="inp" style={{ width: 118, padding: "5px 9px", fontSize: 13 }} value={p.tipo} onChange={(e) => del(i, { ...p, tipo: e.target.value })} disabled={leitura}>
              {["Risco", "Amassado", "Trinca", "Pintura", "Faltante"].map((t) => <option key={t}>{t}</option>)}
            </select>
            <input className="inp" style={{ padding: "5px 9px", fontSize: 13 }} placeholder="Descrição da avaria" value={p.desc} onChange={(e) => del(i, { ...p, desc: e.target.value })} disabled={leitura} />
            {!leitura && <button className="btn btn-g btn-xs" onClick={() => del(i, null)}><Trash2 size={13} /></button>}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Captura de fotos do veículo.
 *
 * A foto é comprimida no aparelho e guardada numa fila local antes de
 * qualquer coisa. O envio acontece depois, sozinho — o mecânico não espera
 * barra de progresso com o cliente na frente, e se a rede estiver ruim ele
 * nem percebe.
 *
 * A prévia usa a imagem local, então aparece na hora mesmo sem sinal.
 */
function Fotos({ fotos, set, leitura, checklistId, toast }) {
  const inp = useRef(null);
  const [ocupado, setOcupado] = useState(false);

  const add = async (e) => {
    const arquivos = Array.from(e.target.files || []);
    e.target.value = "";
    if (!arquivos.length) return;
    setOcupado(true);
    const novas = [], falhas = [];
    for (const arq of arquivos) {
      try {
        // 4 MB do celular viram ~300 KB. É o maior ganho do fluxo inteiro,
        // e acontece aqui, de graça.
        const p = await preparar(arq);
        const filaId = await enfileirarFoto(p, { tipo: "foto_veiculo", checklistId });
        novas.push({ id: filaId, url: URL.createObjectURL(p.blob),
                     nome: arq.name, kb: Math.round(p.bytes / 1024), pendente: true });
      } catch (e) {
        // Uma foto ruim não pode derrubar as outras seis — mas também não
        // pode sumir calada. Antes isto era só um console.error, e no celular
        // do mecânico ninguém abre o console: a foto simplesmente não estava
        // lá depois.
        console.error("nao consegui preparar", arq.name, e);
        falhas.push(arq.name);
      }
    }
    set([...fotos, ...novas]);
    setOcupado(false);
    if (falhas.length) {
      toast?.("Foto não anexada",
        `${falhas.length} foto(s) não puderam ser lidas neste aparelho. Tente fotografar pelo próprio aplicativo em vez de escolher da galeria.`,
        "alerta");
    }
  };

  return (
    <div>
      <div className="grid gap-2.5" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(112px,1fr))" }}>
        {fotos.map((f) => (
          <div key={f.id} className="relative"
            style={{ aspectRatio: "4/3", borderRadius: "var(--r)", overflow: "hidden", border: "1px solid var(--line2)" }}>
            <img src={f.url} alt={f.nome} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            {f.pendente && (
              <span className="absolute mono" style={{ left: 4, bottom: 4, background: "rgba(23,28,34,.8)",
                color: "#fff", fontSize: 9, padding: "1px 5px", borderRadius: 3 }}>
                {f.kb} KB · a enviar
              </span>
            )}
            {!leitura && (
              <button className="absolute" onClick={() => set(fotos.filter((x) => x.id !== f.id))}
                style={{ top: 4, right: 4, background: "rgba(23,28,34,.82)", color: "#fff",
                         border: "none", borderRadius: 4, padding: 4, cursor: "pointer" }}>
                <Trash2 size={12} />
              </button>
            )}
          </div>
        ))}
        {!leitura && (
          <button onClick={() => inp.current?.click()} disabled={ocupado}
            className="flex flex-col items-center justify-center gap-1.5"
            style={{ aspectRatio: "4/3", borderRadius: "var(--r)", border: "1.5px dashed var(--line2)",
                     background: "var(--el)", color: "var(--mut)", cursor: ocupado ? "wait" : "pointer" }}>
            {ocupado ? <Loader2 size={19} className="animate-spin" /> : <Camera size={19} />}
            <span className="text-xs font-semibold">{ocupado ? "Preparando…" : "Adicionar foto"}</span>
          </button>
        )}
      </div>
      <input ref={inp} type="file" accept="image/*" capture="environment" multiple onChange={add} style={{ display: "none" }} />
      {fotos.length === 0 && leitura && <div className="text-sm t-mut2">Nenhuma foto anexada.</div>}
      {!leitura && (
        <div className="text-xs t-mut2 mt-2">
          Recomendado: frontal, traseira, as duas laterais, painel com o hodometro e cada avaria marcada.
          As fotos sao reduzidas no aparelho e enviadas sozinhas quando houver sinal.
        </div>
      )}
    </div>
  );
}

export { Assinatura, MapaAvarias, Fotos };
